import { BATTLE_BOARD_TO_POINT_RELATION, BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION } from '../../BattleConst';
import { BATTLE_STATE, EVENT, TURN_STATE } from './BattleManager';

export class NpcManager {
    constructor(battleManager, npcId, cpuData){
        this.battleManager = battleManager;
        this.battleManager.event.on(EVENT.CHANGE_BATTLE_STATE, (state) => this.changeBattleState(state));
        this.battleManager.event.on(EVENT.CHANGE_TURN_STATE, (state) => this.changeTurnState(state));
        this.npcId = npcId;
        this.handThinkPoint = parseInt(cpuData.aiHand);
        this.valueThinkPoint = parseInt(cpuData.aiBattle);
        this.yakuThinkPoint = parseInt(cpuData.aiCombo);
    }

    changeBattleState(state){
        switch(state){
        case BATTLE_STATE.START_BATTLE:
            // NPCなので即準備完了を返す
            this.battleManager.Ready(false);
            break;
        case BATTLE_STATE.IN_BATTLE:
            break;
        case BATTLE_STATE.END_BATTLE:
            break;
        }
    }
    changeTurnState(state){
        switch(state){
        case TURN_STATE.GUEST_START:
            this.Think();
            break;
        default:
            break;
        }
    }

    async Think(){
        // 即レスすると人間にはターンの切り替わりが認識しづらいので少し待機させる
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // カード思考
        let cardIndex = 0;
        if(Math.random() * 10 <= this.handThinkPoint)
        {
            const cardsData = new Array();
            this.battleManager.guestHands.forEach((card, index) => {
                const cardData = {
                    'index': index,
                    'sum':0,
                    'max':0,
                };
                for(let i = 0; i < 5; i++)
                {
                    const value = card.getVertexValue(i);
                    cardData['sum'] += value;
                    if(cardData['max'] < value)
                    {
                        cardData['max'] = value;
                    }
                }
                cardsData.push(cardData);
            });
            const sumSort = cardsData.sort((a, b) => {
                if(a.sum == b.sum) return 0;
                if(a.sum < b.sum)
                {
                    return 1;
                }
                else
                {
                    return -1;
                }
            });
            const pickLength = Math.ceil(sumSort.length * 0.5);
            const picksData = sumSort.slice(0, pickLength);
            const maxSort = picksData.sort((a, b) => {
                if(a.max == b.max) return 0;
                if(a.max < b.max)
                {
                    return 1;
                }
                else
                {
                    return -1;
                }
            });
            cardIndex = maxSort[0]['index'];
        }
        else
        {
            // 思考なし = ランダム選択
            const cardIndexes = Array.from( this.battleManager.guestHands.keys() );
            cardIndex = cardIndexes[Math.floor(Math.random() * cardIndexes.length)];
        }

        // まず空いてるマスを全抽出
        let boardIndexes = [];
        for(let i = 0; i < 8; i++)
        {
            if(!this.battleManager.putCards.has(i))
            {
                boardIndexes.push(i);
            }
        }

        // 値思考、役思考を経てマスを絞り込む
        if(this.valueThinkPoint == this.yakuThinkPoint){
            if(0.5 <= Math.random()){
                // 値優先
                boardIndexes = this.ThinkValue(boardIndexes, cardIndex);
                boardIndexes = this.ThinkYaku(boardIndexes, cardIndex);
            }else{
                // 役優先
                boardIndexes = this.ThinkYaku(boardIndexes, cardIndex);
                boardIndexes = this.ThinkValue(boardIndexes, cardIndex);
            }
        }else if(this.valueThinkPoint > this.yakuThinkPoint){
            // 値優先
            boardIndexes = this.ThinkValue(boardIndexes, cardIndex);
            boardIndexes = this.ThinkYaku(boardIndexes, cardIndex);
        }else if(this.valueThinkPoint < this.yakuThinkPoint){
            // 役優先
            boardIndexes = this.ThinkYaku(boardIndexes, cardIndex);
            boardIndexes = this.ThinkValue(boardIndexes, cardIndex);
        }

        // ここまで残ったマスからランダムに1マス選ぶ
        const boardIndex = boardIndexes[Math.floor(Math.random() * boardIndexes.length)];

        const rotateCount = this.ThinkRotate(boardIndex, cardIndex);

        this.battleManager.PutCard(this.npcPlayerId, boardIndex, cardIndex, rotateCount);
    }

    ThinkRotate(boardIndex, cardIndex){
        // 回転思考
        // 最大得点を得られる回転を考える
        const pickCard = this.battleManager.guestHands.get(cardIndex);
        // マスの接点を取得
        const pointIndexes = BATTLE_BOARD_TO_POINT_RELATION[boardIndex];
        let rotateData = new Array();
        for(let rotateCount = 0; rotateCount < 5; rotateCount++)
        {
            pickCard.setRotateCount(rotateCount);
            let battlePointCount = 0; // バトルが発生するマスの数
            let battlePointWinCount = 0; // バトルで勝てるマスの数
            let battlePointYakuScore = 0; // 役がで獲得できるスコア
            pointIndexes.forEach(pointIndex => {
                // 接点に関連する全マスを取得
                const relatedBoardIndexes = Object.keys(BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[pointIndex]).map(str => parseInt(str));
                // バトルが発生するか判定
                if(relatedBoardIndexes.every(relatedBoardIndex => {
                    if(boardIndex == relatedBoardIndex) return true;
                    return this.battleManager.putCards.has(relatedBoardIndex);
                })){
                    battlePointCount++;
                    let npcAttack = 0;
                    let playerAttack = 0;
                    relatedBoardIndexes.forEach(relatedBoardIndex => {
                        const relatedBoardVertex = BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[pointIndex][relatedBoardIndex];
                        if(boardIndex == relatedBoardIndex){
                            npcAttack += pickCard.getVertexValue(relatedBoardVertex);
                            return;
                        }
                        const relatedBoardCard = this.battleManager.putCards.get(relatedBoardIndex);
                        if(relatedBoardCard.playerId == this.npcPlayerId)
                        {
                            npcAttack += relatedBoardCard.getVertexValue(relatedBoardVertex);
                        }
                        else
                        {
                            playerAttack += relatedBoardCard.getVertexValue(relatedBoardVertex);
                        }
                    });
                    if(playerAttack < npcAttack)
                    {
                        battlePointWinCount++;
                    }
                }
                // 役計算はバトル有無に関わらず行う（ニコ系の成立があるので）
                const relatedBoardVertex = BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[pointIndex][boardIndex];
                battlePointYakuScore += this.battleManager.checkYaku(boardIndex, pointIndex, pickCard, relatedBoardVertex).ten;
            });
            rotateData.push({
                'rotateCount': rotateCount,
                'priority' : pointIndexes.length - battlePointCount + (battlePointWinCount * 1.1) + (battlePointYakuScore * 1.1)
            });
        }
        // 事故らないようCardDataのrotateCountは初期値に戻しておく
        pickCard.setRotateCount(0);

        rotateData = rotateData.sort((a, b) => {
            if(a.priority == b.priority) return 0;
            if(a.priority < b.priority)
            {
                return 1;
            }
            else
            {
                return -1;
            }
        });
        // priorityポイントが高いマスのみに絞り込む
        const maxPriority = rotateData[0].priority;
        rotateData = rotateData.filter(v => maxPriority <= v.priority);
        return rotateData[Math.floor(Math.random() * rotateData.length)].rotateCount;
    }

    ThinkValue(targetBoardIndexes, cardIndex){
        // 値思考

        // 思考するか判定
        if(this.valueThinkPoint < Math.random() * 10) return targetBoardIndexes;

        const pickCard = this.battleManager.guestHands.get(cardIndex);
        const pickCardData = {
            'sum':0,
            'max':0,
        };
        for(let i = 0; i < 5; i++)
        {
            const value = pickCard.getVertexValue(i);
            pickCardData['sum'] += value;
            if(pickCardData['max'] < value)
            {
                pickCardData['max'] = value;
            }
        }

        let boardsData = new Array();
        targetBoardIndexes.forEach(boardIndex => {
            // マスの接点を取得
            const pointIndexes = BATTLE_BOARD_TO_POINT_RELATION[boardIndex];
            let battlePointCount = 0; // バトルが発生するマスの数
            let battlePointWinCount = 0; // バトルで勝てるマスの数
            pointIndexes.forEach(pointIndex => {
                // 接点に関連する全マスを取得
                const relatedBoardIndexes = Object.keys(BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[pointIndex]).map(str => parseInt(str));
                // バトルが発生するか判定
                if(relatedBoardIndexes.every(relatedBoardIndex => {
                    if(boardIndex == relatedBoardIndex) return true;
                    return this.battleManager.putCards.has(relatedBoardIndex);
                })){
                    battlePointCount++;
                    let npcAttack = pickCardData.max;
                    let playerAttack = 0;
                    relatedBoardIndexes.forEach(relatedBoardIndex => {
                        if(boardIndex == relatedBoardIndex) return;
                        const relatedBoardCard = this.battleManager.putCards.get(relatedBoardIndex);
                        const relatedBoardVertex = BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[pointIndex][relatedBoardIndex];
                        if(relatedBoardCard.playerId == this.npcPlayerId)
                        {
                            npcAttack += relatedBoardCard.getVertexValue(relatedBoardVertex);
                        }
                        else
                        {
                            playerAttack += relatedBoardCard.getVertexValue(relatedBoardVertex);
                        }
                    });
                    if(playerAttack < npcAttack)
                    {
                        battlePointWinCount++;
                    }
                }
            });
            boardsData.push({
                'index': boardIndex,
                // 空きマスとバトルで勝てるマスを合計して優先度を計算。特にバトルで勝てるマスは優先するよう 1.1 ポイントとして計算
                'priority' : pointIndexes.length - battlePointCount + (battlePointWinCount * 1.1)
            });
        });
        boardsData = boardsData.sort((a, b) => {
            if(a.priority == b.priority) return 0;
            if(a.priority < b.priority)
            {
                return 1;
            }
            else
            {
                return -1;
            }
        });
        // priorityポイントが高いマスのみに絞り込む
        const maxPriority = boardsData[0].priority;
        boardsData = boardsData.filter(v => maxPriority <= v.priority);
        return boardsData.map(v => v.index);
    }

    ThinkYaku(targetBoardIndexes, cardIndex){
        // 役思考

        // 思考するか判定
        if(this.yakuThinkPoint < Math.random() * 10) return targetBoardIndexes;

        const pickCard = this.battleManager.guestHands.get(cardIndex);

        let boardsData = new Array();
        targetBoardIndexes.forEach(boardIndex => {
            // マスの接点を取得
            const pointIndexes = BATTLE_BOARD_TO_POINT_RELATION[boardIndex];
            let battlePointCount = 0; // バトルが発生するマスの数
            let battlePointYakuPoint = 0; // バトルで勝てるマスの数
            pointIndexes.forEach(pointIndex => {
                // 接点に関連する全マスを取得
                const relatedBoardIndexes = Object.keys(BATTLE_POINT_TO_BOARD_AND_VERTEX_RELATION[pointIndex]).map(str => parseInt(str));
                // バトルが発生するか判定
                if(relatedBoardIndexes.every(relatedBoardIndex => {
                    if(boardIndex == relatedBoardIndex) return true;
                    return this.battleManager.putCards.has(relatedBoardIndex);
                })){
                    battlePointCount++;
                    // 何かしらの役が作れるか計算
                    for(let vertex = 0; vertex < 5; vertex++)
                    {
                        const yaku = this.battleManager.checkYaku(boardIndex, pointIndex, pickCard, vertex);
                        if(battlePointYakuPoint < yaku.ten)
                        {
                            battlePointYakuPoint = yaku.ten;
                        }
                    }
                }
            });
            boardsData.push({
                'index': boardIndex,
                // 空きマスとバトルで勝てるマスを合計して優先度を計算。特にバトルで勝てるマスは優先するよう 1.1 ポイントとして計算
                'priority' : pointIndexes.length - battlePointCount + (battlePointYakuPoint * 1.1)
            });
        });
        boardsData = boardsData.sort((a, b) => {
            if(a.priority == b.priority) return 0;
            if(a.priority < b.priority)
            {
                return 1;
            }
            else
            {
                return -1;
            }
        });
        // priorityポイントが高いマスのみに絞り込む
        const maxPriority = boardsData[0].priority;
        boardsData = boardsData.filter(v => maxPriority <= v.priority);
        return boardsData.map(v => v.index);
    }
}
